import React, { useState } from "react";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { storage } from "../../../firebase/firebaseConfig";
import { ProgressBar } from "react-bootstrap";

// Function to generate unique file name
const generateUniqueFileName = (originalFileName) => {
  const timestamp = Date.now();
  const randomString = Math.random().toString(36).substring(2, 15);
  const fileExtension = originalFileName.split('.').pop();
  const fileNameWithoutExtension = originalFileName.substring(0, originalFileName.lastIndexOf('.'));
  
  // Create a sanitized version of the original name (remove special characters)
  const sanitizedName = fileNameWithoutExtension.replace(/[^a-zA-Z0-9]/g, '_');
  
  return `${sanitizedName}_${timestamp}_${randomString}.${fileExtension}`;
};

const FirebaseUploadFile = ({ name, onBlur, onChange }) => {
  const [uploadName, setUploadName] = useState("Upload Receipt*");
  const [uploadProgress, setUploadProgress] = useState(null);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setUploadName(file.name);

    // Generate unique file name for Firebase storage
    const uniqueFileName = generateUniqueFileName(file.name);
    console.log("uniqueFileName", uniqueFileName);
    const storageRef = ref(storage, `uploads/${uniqueFileName}`);
    const uploadTask = uploadBytesResumable(storageRef, file);

    uploadTask.on(
      "state_changed",
      (snapshot) => {
        const progress =
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        console.log("Upload progress: ", progress);
        setUploadProgress(progress);
      },
      (error) => {
        console.error("Error uploading file:", error);
      },
      async () => {
        const downloadUrl = await getDownloadURL(uploadTask.snapshot.ref);
        // formik.setFieldValue("uploadReceipt", downloadUrl);
        onChange(downloadUrl);
      }
    );
  };
  return (
    <>
      <div className="uploadLogoContainer uploadVendorFile">
        <div className="uploadContainer">
          <input
            type="file"
            name={name}
            onChange={handleFileChange}
            onBlur={onBlur}
          />

          <label htmlFor="actual-btn">UPLOAD</label>
          <span id={`fileChosen choosenFile`}>{uploadName}</span>
        </div>
      </div>
      <ProgressBar now={uploadProgress} style={{ width: "100%" }} />
    </>
  );
};

export default FirebaseUploadFile;
